import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPlay,FiUsers,FiFileText,FiMonitor,FiMail,FiShare2,FiCalendar,FiHeadphones}=FiIcons;

const Features=()=> {
  const features=[
    {
      icon: FiPlay,
      title: "Video Tutorial Library",
      description: "Access 50+ professional video tutorials covering every aspect of business growth, from beginner to advanced strategies.",
      highlights: ["Step-by-step walkthroughs","Mobile-friendly viewing","Downloadable resources"]
    },
    {
      icon: FiUsers,
      title: "Weekly Group Calls",
      description: "Join live group coaching sessions every week with business experts and fellow entrepreneurs.",
      highlights: ["Live Q&A sessions","Expert guest speakers","Networking opportunities"]
    },
    {
      icon: FiFileText,
      title: "Ready-to-Use Templates",
      description: "Get professionally designed templates for marketing campaigns, social media posts, and business documents.",
      highlights: ["Customizable designs","Industry-specific options","Instant download"]
    },
    {
      icon: FiMonitor,
      title: "Website Optimization",
      description: "Learn how to create and optimize websites that convert visitors into customers with our detailed guides.",
      highlights: ["SEO best practices","Conversion optimization","Mobile responsiveness"]
    },
    {
      icon: FiMail,
      title: "Email Marketing Mastery",
      description: "Master email marketing with templates, automation sequences, and proven strategies that drive sales.",
      highlights: ["Automation workflows","Subject line formulas","Segmentation strategies"]
    },
    {
      icon: FiShare2,
      title: "Social Media Strategy",
      description: "Dominate social media with content calendars, posting strategies, and engagement tactics that build your brand.",
      highlights: ["Content planning","Platform-specific tips","Growth hacking techniques"]
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Everything You Need to
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent block">
              Grow Your Business
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our comprehensive system includes all the tools, training, and support
            you need to build a thriving business.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8">
          {features.map((feature,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,x: index % 2===0 ? -30 : 30}}
              whileInView={{opacity: 1,x: 0}}
              transition={{duration: 0.8,delay: index * 0.1}}
              viewport={{once: true}}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start space-x-6">
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={feature.icon} className="text-white text-xl" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{feature.description}</p>
                  <ul className="space-y-2">
                    {feature.highlights.map((highlight,idx)=> (
                      <li key={idx} className="flex items-center text-sm text-gray-500">
                        <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mr-3"></div>
                        {highlight}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bonus features */}
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8,delay: 0.4}}
          viewport={{once: true}}
          className="mt-16 bg-white p-8 rounded-2xl shadow-lg border border-gray-100"
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Plus These Bonus Features</h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-center space-x-4">
              <SafeIcon icon={FiCalendar} className="text-blue-600 text-xl" />
              <span className="text-gray-700">Monthly Business Planning Sessions</span>
            </div>
            <div className="flex items-center space-x-4">
              <SafeIcon icon={FiHeadphones} className="text-purple-600 text-xl" />
              <span className="text-gray-700">24/7 Community Support Forum</span>
            </div>
          </div>
        </motion.div>

        {/* Value statement */}
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8,delay: 0.6}}
          viewport={{once: true}}
          className="text-center mt-16"
        >
          <div className="bg-gradient-to-r from-green-500 to-blue-600 text-white p-8 rounded-2xl shadow-2xl">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Total Value: $2,497
            </h3>
            <p className="text-xl mb-2 opacity-90">
              Your Investment: Only $99/month
            </p>
            <p className="text-lg opacity-75">
              Try it FREE for 7 days - No credit card required
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Features;